<script setup lang="ts">
import { lectureService } from '@/api/services/lecture-service'
import BaseLayout from '@/components/base/BaseLayout.vue'
import RecommendContentSection from '@/features/dashboard/components/RecommendContentSection.vue'
import VideoInfoSection from '@/features/video/components/VideoInfoSection.vue'
import VideoPlayer from '@/features/video/components/VideoPlayer.vue'
import type { LectureDetail } from '@/types/lecture.types'
import { onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const lecutreDetail = ref<LectureDetail>()
const enterTime = ref<number>(Date.now())
const previousLectureId = ref<number | null>(null)

const updateWatchTime = async (lectureId: number) => {
  try {
    const watchTime = Math.floor((Date.now() - enterTime.value) / 1000)
    await lectureService.updateStatistic(lectureId, watchTime)

    enterTime.value = Date.now()
  } catch (error) {
    console.error('시청 시간 업데이트 실패:', error)
  }
}

const fetchLectureDetail = async (newId: string) => {
  // 이전 강의의 시청 시간 업데이트
  if (previousLectureId.value) {
    await updateWatchTime(previousLectureId.value)
  }

  // 새로운 강의 정보 가져오기
  lecutreDetail.value = await lectureService.getLectureDetail(Number(newId))
  previousLectureId.value = Number(newId)

  // 새로운 시간 측정 시작
  enterTime.value = Date.now()
}

watch(
  () => route.params.id,
  (newId) => {
    if (newId && typeof newId === 'string') {
      fetchLectureDetail(newId)
    }
  },
  { immediate: true },
)

onMounted(() => {
  enterTime.value = Date.now()
  window.addEventListener('beforeunload', handleBeforeUnload)
})

onUnmounted(async () => {
  window.removeEventListener('beforeunload', handleBeforeUnload)

  if (previousLectureId.value) {
    await updateWatchTime(previousLectureId.value)
  }
})

const handleBeforeUnload = async (event: BeforeUnloadEvent) => {
  console.log('beforeunload')
  event.preventDefault()
  event.returnValue = false

  if (previousLectureId.value) {
    await updateWatchTime(previousLectureId.value)
  }
}
</script>

<template>
  <BaseLayout :padding="'12px 40px 40px 40px'">
    <div v-if="lecutreDetail" class="video-view">
      <VideoPlayer :key="String(route.params.id)" :lecture="lecutreDetail" />
      <VideoInfoSection :key="String(route.params.id)" :lecture="lecutreDetail" />
      <RecommendContentSection :key="String(route.params.id)" :marginTop="0" />
    </div>
  </BaseLayout>
</template>

<style scoped>
.video-view {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (max-width: 1365px) {
  .video-view {
    gap: 0px;
  }
}
</style>
